

































import { SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WSurveyAnswersUnsent extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	copyId = "sx_copy_element";

	get isAdmin() {
		return this.$services.users.isAdmin();
	}

	get answersLogs() {
		return this.$services.answers
			.getSurveyUnsentAnswers(this.survey)
			.sort(function(a, b) {
				return b.time - a.time;
			});
	}

	get unsentTotal() {
		return this.answersLogs.length;
	}

	get unsentCounterMessage() {
		let x = this;
		return x.i18n(
			"SX_LANG_ANSWERS_COUNT",
			{ count: x.unsentTotal },
			function() {
				return x.unsentTotal > 1 ? 1 : 0;
			}
		);
	}

	sendUnsentAnswers() {
		this.$services.answers.startUnsentAnswersSender();
	}
	copyUnsentAnswers() {
		try {
			let copyText: any = document.getElementById(this.copyId);
			let data = this.$services.answers.getUnsentAnswers();
			copyText.textContent = JSON.stringify(data);
			copyText.select();
			document.execCommand("copy");
			copyText.textContent = "";
			this.$app.view.dialog({
				type: "done",
				text: "SX_LANG_COPY_TO_CLIPBOARD_DONE"
			});
		} catch (e) {
			this.$app.view.dialog({
				type: "error",
				text: "SX_LANG_COPY_TO_CLIPBOARD_ERROR"
			});
		}
	}
}
